import { FETCH_LIST_START, FETCH_LIST_SUCCESS, FETCH_LIST_FAIL } from '../actions/actionTypes';

const initialState = {
    mainTypes: {
        data: [],
        loading: false,
        error: null
    },
    itemTypes: {
        data: [],
        loading: false,
        error: null
    },
    items: {
        data: [],
        loading: false,
        error: null
    },
    nearbyItems: {
        data: [],
        loading: false,
        error: null
    },
    popularLocations: {
        data: [],
        loading: false,
        error: null
    },
    searchAutocomplete: {
        data: [],
        loading: false,
        error: null
    },
    addresses: {
        data: [],
        loading: false,
        error: null
    },
    countries: {
        data: [],
        loading: false,
        error: null
    },
    reservations: {
        data: [],
        loading: false,
        error: null
    },
    orders: {
        data: [],
        loading: false,
        error: null
    },
    orderReservations: {
        data: [],
        loading: false,
        error: null
    },
    paymentAccounts: {
        data: [],
        loading: false,
        error: null
    },
    paymentMethods: {
        data: [],
        loading: false,
        error: null
    },
    paymentOptions: {
        data: [],
        loading: false,
        error: null
    },
    directDebits: {
        data: [],
        loading: false,
        error: null
    }
};

/* * * * * * * * * * * * * * * * * * * * * * * * *
* METHODS THAT UPDATE STATES WITH CORRECT VALUES *
* * * * * * * * * * * * * * * * * * * * * * * *  */
const fetchListStart = (state, action) => {
    const updatedInnerStates = {...state[action.identifier], ...{
        loading: true
    }};

    return {...state, ...{
        [action.identifier]: updatedInnerStates
    }};
};

const fetchListSuccess = (state, action) => {
    const updatedInnerStates = {...state[action.identifier], ...{
        data: action.concat ? state[action.identifier].data.concat(action.data) : action.data,
        loading: false,
        error: null
    }};

    return {...state, ...{
        [action.identifier]: updatedInnerStates
    }};
};

const fetchListFail = (state, action) => {
    const updatedInnerStates = {...state[action.identifier], ...{
        data: [],
        loading: false,
        error: action.error
    }};

    return {...state, ...{
        [action.identifier]: updatedInnerStates
    }};
};

/* * * * * * * * *
* REDUCER METHOD *
* * * * * * * *  */
// Depending on the active action type, execute the correct function to update the correct states with the correct values
// Pass two parameters, first is the old state values, second is the new state values, these are passed from actions
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_LIST_START: return fetchListStart(state, action);
        case FETCH_LIST_SUCCESS: return fetchListSuccess(state, action);
        case FETCH_LIST_FAIL: return fetchListFail(state, action);
        default: return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/list.js